export default function makeDefaultState (servicePath, options) {
  const { idField, autoRemove, enableEvents, addOnUpsert, diffOnPatch, skipRequestIfExists, preferUpdate, replaceItems } = options
  const state = {
    servicePath: servicePath,
    data: null,
    isFindPending: false,
    isGetPending: false,
    isCreatePending: false,
    isUpdatePending: false,
    isPatchPending: false,
    isRemovePending: false,
    errorOnFind: null,
    errorOnGet: null,
    errorOnCreate: null,
    errorOnUpdate: null,
    errorOnPatch: null,
    errorOnRemove: null,
    ids: [],
    keyedById: {},
    copiesById: {},
    currentId: null,
    copy: null,
    expandedItems: [],
    idField,
    autoRemove,
    enableEvents,
    addOnUpsert,
    diffOnPatch,
    skipRequestIfExists,
    preferUpdate,
    replaceItems,
    pagination: {},
    canceller: null
  }
  return state
}
